import React, {useState, useEffect} from 'react';
import useInterval from '../../../../customHooks/useInterval';

const VestGuyEvent = props => {
    const [eventActive, setEventActive] = useState(false);
    const [eventOver, setEventOver] = useState(false);
    const ANIMATION_FRAMERATE = 1000 / 60;
    const [animationFramerate, setAnimationFramerate] = useState(null);
    const [animationTime, setAnimationTime] = useState(0);
    const previousAnimationTime = React.useRef(0);
    const [activeAudioList, setActiveAudioList] = useState([]);
    const [flipped, setFlipped] = useState(false);

    const styleObject = {
        transform: `translate3d(${
            props.xOffset
        }%, ${
            props.yOffset
        }%, ${
            props.zOffset
        }px)`,
        zIndex: props.zIndex
    }

    useInterval(() => {
        if (eventActive && !eventOver) {  
            setAnimationTime(animationTime + animationFramerate);

             if(animationTime < props.data.animationTimeout){  
                       
                const eventsToProcess = props.data.timedEvents.filter((e,i,a)=>{
                    if (e.time>previousAnimationTime.current && e.time<=animationTime) return true
                    return false
                })

                eventsToProcess.forEach(e=>{
                    console.log("Dispatching Events" , e)
                    switch (e.event) {
                        case 'window':
                            props.setSideTrainVisible(e.value==='none' ? null : e.value)
                            break;
                        case 'road':
                             props.updateRoad(e.value)
                             if (props.data.silentCrossing === false){
                                props.audioController.removeAudio("longLongShortLongHorn")
                            }
                            break;
                        case 'startAudio':
                            startAudio(e.value)
                            break;  
                        case 'endAudio':
                            stopAudio(e.value)
                        break;          
                        case 'flash_crossing_lights':
                            props.updateRoad(e.value === true ? 'startAnimateCrossing' : 'stopAnimatedCrossing')

                            console.log("Flash Crossing Lights: ", e.value, props)
                            break
                        case 'internal':
                            if (e.value = 'signChange') setFlipped(true);
                            
                            break
                        default:
                            break;
                    }
                })
             } else{
                setAnimationFramerate(null) // Stop the interval
                activeAudioList.forEach(e=>{ 
                    props.audioController.removeAudio(e); // remove all active audios
                 })
                 setActiveAudioList([]) // reset the active audio list

                 setEventActive(false) // check to see if these are needed
                 setEventOver(true);

                // add event to the completed events
                props.setCompletedRoadEvents( (state)=>{
                        const newCompletedEvents = [...state];
                        newCompletedEvents[props.data.eventId] = true;
                        return newCompletedEvents
                    }
                )
             }
             previousAnimationTime.current = animationTime;
         }  
         return () => {
             return 
         }
     }, animationFramerate)

     const startAudio = (audioName) => {
        props.audioController.playAudioByName(audioName);
        setActiveAudioList((list)=>{
            if (list.indexOf(audioName) === -1){
                return ([...list, audioName])
            } 
            return list
        })       
    }
    const stopAudio = (audioName) => {
        props.audioController.playAudioByName(audioName);
        setActiveAudioList((list)=>{
            if (list.indexOf(audioName) !== -1){
                return ([...list].splice(list.indexOf(audioName),1))
            } 
            return list
        })       
    }
    const startAnimation = () => {
        setAnimationFramerate(ANIMATION_FRAMERATE)
        setEventActive(true);
    }

    useEffect(() => {
        if (props.didStopCorrectly) {
            if(props.delay){
                const trainTimeout = setTimeout(() => {
                    startAnimation()
                }, (props.delay * 1000));
                // clear timeout before unmount
                return () => clearTimeout(trainTimeout)
            }else{
                setAnimationFramerate(ANIMATION_FRAMERATE)
                setEventActive(true);
            }
        }
    }, [props.didStopCorrectly])

    return (
        <div className={`VestGuyEvent`} style={styleObject}>
            <div className={`sign-container ${flipped ? 'flipped' : ''}`}>
                <div className={`slow`} />
                <div className={`stop`} />
            </div>
        </div>
    )
}

export default VestGuyEvent